import React from "react";
import { Check, Input } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import { Col, Form } from "react-bootstrap";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import type EnforcementTabletCreateViewModel from "viewModels/enforcement/enforcementTablets/enforcementTabletCreateViewModel";
import EnforcementTabletDetailViewModel from "viewModels/enforcement/enforcementTablets/enforcementTabletDetailViewModel";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatDateTime } from "utils/localizations";

export interface EnforcementTabletFormProps {
  vm: EnforcementTabletCreateViewModel | EnforcementTabletDetailViewModel;
  children?: React.ReactNode;
}

const EnforcementTabletForm = observer((props: EnforcementTabletFormProps) => {
  const { vm, children } = props;
  const disabled = !vm.isEditable;

  const detailView = vm instanceof EnforcementTabletDetailViewModel && (
    <>
      <Form.Row>
        <FormGroup as={Col} md={12} target={vm.detail} property="id">
          <FormLabel>{vm.translate("id")}</FormLabel>
          <FakeInput />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} md={6} target={vm.detail} property="createdAt">
          <FormLabel>{vm.translate("createdAt")}</FormLabel>
          <FakeInput valueFormatter={value => formatDateTime(value)} />
        </FormGroup>
        <FormGroup as={Col} md={6} target={vm.detail} property="updatedAt">
          <FormLabel>{vm.translate("updatedAt")}</FormLabel>
          <FakeInput valueFormatter={value => formatDateTime(value)} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} md={6} target={vm.detail} property="createdBy">
          <FormLabel>{vm.translate("createdBy")}</FormLabel>
          <FakeInput />
        </FormGroup>
        <FormGroup as={Col} md={6} target={vm.detail} property="updatedBy">
          <FormLabel>{vm.translate("updatedBy")}</FormLabel>
          <FakeInput />
        </FormGroup>
      </Form.Row>
      <hr />
    </>
  );

  return (
    <>
      {detailView}
      <Form.Row>
        <FormGroup as={Col} md={6} target={vm.item} property="hostname">
          <FormLabel>{vm.translateAttribute("hostname")}</FormLabel>
          <Input placeholder={vm.translate("hostnamePlaceholder")} disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} md={6} target={vm.item} property="alias">
          <FormLabel>{vm.translateAttribute("alias")}</FormLabel>
          <Input placeholder={vm.translate("aliasPlaceholder")} disabled={disabled} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} md={12} target={vm.item} property="isEnabled">
          <FormLabel>{vm.translateAttribute("isEnabled")}</FormLabel>
          <Check custom type="checkbox" disabled={disabled} label={vm.translate("isEnabled")} />
        </FormGroup>
      </Form.Row>
      {children}
    </>
  );
});

export default EnforcementTabletForm;
